var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgAbout2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1120,
    height: 753,
    viewBox: "0 0 1120 753",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-176 0L768 327L1120 753L403 365L-176 0Z",
    fill: "#FBDDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAbout2);
export default __webpack_public_path__ + "static/media/bgAbout2.4cbe4960e8a901d7a10b13f94d68d80a.svg";
export { ForwardRef as ReactComponent };